import React from "react";
import { styled } from "@mui/material/styles";
import {
  AppBar as MuiAppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Avatar,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    [theme.breakpoints.up("md")]: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  }),
}));

const DashboardAppBar = ({
  open,
  user,
  handleDrawerOpen, // <-- YEH PROP AB ISTEMAL HOGA
  handleMobileDrawerToggle,
  handleLogout,
}) => {
  return (
    <AppBar position="fixed" open={open}>
      <Toolbar>
        {/* === YAHAN BADLAV KIYA GAYA HAI === */}
        {/* Desktop - Drawer open karne ka icon */}
        {/* Yeh sirf desktop par aur tabhi dikhega jab drawer band ho */}
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          sx={{
            marginRight: 2,
            display: { xs: "none", md: "inline-flex" }, // Sirf Desktop par
            ...(open && { display: "none" }), // Agar drawer open hai toh hide kar do
          }}
        >
          <MenuIcon />
        </IconButton>

        {/* Mobile - Drawer open karne ka icon */}
        <IconButton
          color="inherit"
          aria-label="open mobile drawer"
          edge="start"
          onClick={handleMobileDrawerToggle}
          sx={{
            mr: 2,
            display: { md: "none" }, // Sirf Mobile par
            ...(!open && { display: { xs: "inline-flex", md: "none" } }), // Agar desktop drawer band hai to bhi mobile pr dikhe
          }}
        >
          <MenuIcon />
        </IconButton>

        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
          Dashboard
        </Typography>

        {user && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Avatar
              src={user.photoURL}
              sx={{ width: 32, height: 32 }}
              alt={user.displayName || user.email}
            />
            <Typography sx={{ display: { xs: "none", sm: "block" } }}>
              {user.displayName || user.email}
            </Typography>
            <Button
              color="inherit"
              variant="outlined"
              size="small"
              onClick={handleLogout}
              startIcon={<LogoutIcon />}
              sx={{
                borderColor: "rgba(255,255,255,0.5)",
                "&:hover": { borderColor: "white" },
              }}
            >
              Logout
            </Button>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default DashboardAppBar;
